import React, { useEffect, useState, useRef } from 'react';
import {
  Button,
  Col,
  message,
  MessageBox,
  Row,
  DatePicker,
  Form,
} from 'kenshin';
import TablePro from '@/components/TablePro';
import { connect } from 'umi';
import ModalFormPro from '@/components/ModalFormPro';
import { useCreation } from 'ahooks';
import moment from 'moment';

const { RangePicker } = DatePicker;

const ActivityPlanPage = ({ dispatch, loading, activityPlan }) => {
  let tableRef = useRef();
  let modalRef = useRef();

  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editModalData, setEditModalData] = useState(null);
  const [dateRange, setDateRange] = useState([]);

  // 初始化日期范围为当前年的开始和结束
  useEffect(() => {
    const currentYear = moment().year();
    const startOfYear = moment().startOf('year');
    const endOfYear = moment().endOf('year');
    setDateRange([startOfYear, endOfYear]);
  }, []);

  // 日期变化时重新加载数据
  useEffect(() => {
    if (dateRange.length === 2 && tableRef?.reload) {
      tableRef.reload({
        startDate: dateRange[0]?.format('YYYY-MM-DD'),
        endDate: dateRange[1]?.format('YYYY-MM-DD'),
      });
    }
  }, [dateRange]);

  const showEditModal = (row) => {
    setEditModalVisible(true);
    if (row) {
      setEditModalData({
        ...row,
        dateRange: [moment(row.startDate), moment(row.endDate)],
        isHoliday: row.isHoliday?.toString() || '',
      });
    } else {
      let start = moment().startOf('d');
      let end = moment().endOf('d');

      setEditModalData({ dateRange: [start, end], isHoliday: '0' });
    }
  };

  const delPlan = (row) => {
    MessageBox.confirm({
      title: '确认操作',
      content: '确认删除该活动计划？删除后无法恢复',
      onOk: () => {
        dispatch({
          type: 'activityPlan/deleteActivityPlan',
          payload: { id: row.id },
        }).then((res) => {
          if (res) {
            message.success('删除成功');
            tableRef.reload({
              startDate: dateRange[0]?.format('YYYY-MM-DD'),
              endDate: dateRange[1]?.format('YYYY-MM-DD'),
            });
          }
        });
      },
    });
  };

  const editModalSave = (value) => {
    const payload = {
      ...value,
      startDate: value.dateRange?.[0]?.format('YYYY-MM-DD HH:mm:ss'),
      endDate: value.dateRange?.[1]?.format('YYYY-MM-DD HH:mm:ss'),
    };
    delete payload.dateRange;

    const hasEdit = !!editModalData?.id;
    if (hasEdit) {
      payload.id = editModalData.id;
    }

    dispatch({
      type: hasEdit
        ? 'activityPlan/updateActivityPlan'
        : 'activityPlan/addActivityPlan',
      payload,
    }).then((res) => {
      if (res) {
        message.success(hasEdit ? '修改成功' : '新增成功');
        setEditModalData(null);
        setEditModalVisible(false);
        tableRef.reload({
          startDate: dateRange[0]?.format('YYYY-MM-DD'),
          endDate: dateRange[1]?.format('YYYY-MM-DD'),
        });
      }
    });
  };

  const columns = [
    {
      title: '名称',
      width: 200,
      dataIndex: 'name',
      key: 'name',
    },
    // {
    //   title: '类型',
    //   width: 100,
    //   dataIndex: 'type',
    //   key: 'type',
    //   render: (val) => (val == '1' ? '节假日修改' : '活动'),
    // },
    {
      title: '开始时间',
      width: 150,
      dataIndex: 'startDate',
      key: 'startDate',
    },
    {
      title: '结束时间',
      width: 150,
      dataIndex: 'endDate',
      key: 'endDate',
    },
    {
      title: '假期标识',
      width: 100,
      dataIndex: 'isHoliday',
      key: 'isHoliday',
      render: (val) => (val === 1 ? '是' : '否'),
    },
    {
      title: '备注',
      width: 300,
      dataIndex: 'remark',
      key: 'remark',
      ellipsis: true,
    },
    {
      title: '操作',
      width: 150,
      fixed: 'right',
      key: 'options',
      render: (row) => {
        return (
          <>
            <Button type="text" onClick={() => showEditModal(row)}>
              编辑
            </Button>
            <Button
              type="text"
              style={{ color: 'red' }}
              onClick={() => delPlan(row)}
            >
              删除
            </Button>
          </>
        );
      },
    },
  ];

  const searchCloumns = [
    {
      name: 'name',
      type: 'Input',
      props: {
        placeholder: '请输入名称',
      },
    },
  ];

  // 弹窗formItem
  const edtaFormItem = [
    // {
    //   label: '类型',
    //   name: 'type',
    //   type: 'Select',
    //   props: {
    //     placeholder: '请选择类型',
    //     options: [
    //       { label: '节假日修改', value: 1 },
    //       { label: '活动', value:2 },
    //     ],
    //   },
    // },
    {
      label: '名称',
      name: 'name',
      type: 'Input',
      required: '请输入名称',
      props: {
        placeholder: '请输入名称',
      },
    },
    {
      label: '时间范围',
      name: 'dateRange',
      type: 'DatePickerRangePicker',
      required: '请选择时间范围',
      props: {
        placeholder: ['开始时间', '结束时间'],
        showTime: {
          format: 'HH:mm',
        },
      },
    },
    {
      label: '假期标识',
      name: 'isHoliday',
      type: 'Select',
      props: {
        placeholder: '请选择',
        options: [
          { label: '否', value: '0' },
          { label: '是', value: '1' },
        ],
      },
    },
    {
      label: '备注',
      name: 'remark',
      type: 'InputTextArea',
      props: {
        placeholder: '请输入备注',
        rows: 3,
      },
    },
  ];

  const extra = () => (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <RangePicker
        value={dateRange}
        onChange={handleDateRangeChange}
        format="YYYY-MM-DD"
        placeholder={['开始时间', '结束时间']}
      />
      <Button type="primary" key={btnKeys.add} onClick={() => showEditModal()}>
        新增活动计划
      </Button>
    </div>
  );

  const handleDateRangeChange = (dates) => {
    setDateRange(dates || []);
  };

  const tableSubmit = (val) => {
    if (!dateRange[0]) return false;
    if (!dateRange[1]) return false;
    return {
      ...val,
      startDate: dateRange[0]?.format('YYYY-MM-DD'),
      endDate: dateRange[1]?.format('YYYY-MM-DD'),
    };
  };

  return (
    <>
      <TablePro
        request="activityPlan/getActivityPlanByDateRange"
        version="activityPlan"
        rowKey="id"
        scrollX
        columns={columns}
        data={activityPlan.planList}
        columnsOptions={false}
        extra={extra}
        curColumns
        onSubmit={tableSubmit}
        actionRef={(ref) => (tableRef = ref)}
      />

      <ModalFormPro
        title={editModalData?.id ? '编辑活动计划' : '新增活动计划'}
        visible={editModalVisible}
        edtaFormItem={edtaFormItem}
        formData={editModalData}
        ref={modalRef}
        onSave={editModalSave}
        onCancel={() => {
          setEditModalData(null);
          setEditModalVisible(false);
        }}
      />
    </>
  );
};

export default connect(({ activityPlan, loading }) => {
  return {
    activityPlan,
    loading: loading.effects,
  };
})(ActivityPlanPage);
